import '../lib/globals/babel'
import '../lib/chunk_load_handler'

import loadPolyfills from '../lib/polyfills'

import '../lib/init.scss'
import { hasStorageAccess, requestStorageAccess } from './util/handleStorageAccess'
import { setupApiProxy } from './util/setupApiProxy'
import isZoomApp from '../lib/util/is_zoom_app'
import configureZoomApp from '../lib/util/zoom_app_config'

const APPNAME = 'Poll Everywhere Embed'

async function bootApp () {
  setupApiProxy()

  const startAppLoader = (await import(/* webpackChunkName: "start-app" */ './util/startApp'))

  const opts = {
    role: 'embed',
    appName: APPNAME,
    serviceWorker: false,
    typekit: false,
    outOfBandAuth: true
  }

  startAppLoader.startApp(opts)
  if (isZoomApp()) {
    await configureZoomApp()
  }
}

loadPolyfills().then(async () => {
  if (navigator.onLine) {
    try {
      if (!(await hasStorageAccess()) && !isZoomApp()) {
        await requestStorageAccess()
      }
      bootApp()
    } catch (e) {
      window.console?.error?.('Cannot access storage', e)
      const storageErrorMessage = (await import(/* webpackChunkName: 'storage-error-message' */ './util/storageErrorMessage')).storageErrorMessage
      storageErrorMessage(APPNAME, e)
    }
  } else {
    const offlineMessage = (await import(/* webpackChunkName: 'offline-message' */ './util/offlineMessage')).offlineMessage
    offlineMessage(APPNAME)
  }
})
